import { StatusOption } from '../../utils'

export enum ApplicationStatusEnum {
  AFFECTED = 'AFFECTED',
  CANCELLED_BEFORE_CONFIRMATION = 'CANCELLED_BEFORE_CONFIRMATION',
  CANCELLED_AFTER_CONFIRMATION = 'CANCELLED_AFTER_CONFIRMATION',
  CONFIRMED = 'CONFIRMED',
  QUOTE = 'QUOTE',
  INCOMPLETE_REGISTRATION = 'INCOMPLETE_REGISTRATION',
  TO_BE_CONTACTED = 'TO_BE_CONTACTED',
  PENDING_CLIENT_VALIDATION = 'PENDING_CLIENT_VALIDATION',
  PENDING_LEC_CONFIRMATION = 'PENDING_LEC_CONFIRMATION',
  PENDING_CSE_VALIDATION = 'PENDING_CSE_VALIDATION',
  REJECTED_BY_CSE = 'REJECTED_BY_CSE'
}

export const applicationStatusEnumMapping: Record<ApplicationStatusEnum, StatusOption> = {
  [ApplicationStatusEnum.CONFIRMED]: {
    label: 'Confirmé',
    variant: 'success'
  },
  [ApplicationStatusEnum.PENDING_LEC_CONFIRMATION]: {
    label: 'En attente de validation LEC',
    variant: 'blue'
  },
  [ApplicationStatusEnum.PENDING_CLIENT_VALIDATION]: {
    label: 'En attente de validation client',
    variant: 'warning'
  },
  [ApplicationStatusEnum.QUOTE]: {
    label: 'Devis',
    variant: 'grey'
  },
  [ApplicationStatusEnum.INCOMPLETE_REGISTRATION]: {
    label: 'Inscription incomplète',
    variant: 'grey'
  },
  [ApplicationStatusEnum.TO_BE_CONTACTED]: {
    label: 'À recontacter',
    variant: 'warning'
  },
  [ApplicationStatusEnum.CANCELLED_BEFORE_CONFIRMATION]: {
    label: 'Annulé avant confirmation',
    variant: 'danger'
  },
  [ApplicationStatusEnum.CANCELLED_AFTER_CONFIRMATION]: {
    label: 'Annulé après confirmation',
    variant: 'danger'
  },
  [ApplicationStatusEnum.AFFECTED]: {
    label: 'Affecté',
    variant: 'blue'
  },
  [ApplicationStatusEnum.PENDING_CSE_VALIDATION]: {
    label: 'En attente de validation CSE',
    variant: 'warning'
  },
  [ApplicationStatusEnum.REJECTED_BY_CSE]: {
    label: 'Rejeté par le CSE',
    variant: 'danger'
  }
}
